'use client';

import { type ElementType, forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Slot } from '../slot';
import { BannerIcon } from './banner-icon';
import { bannerBodyStyles } from './styles/banner-body.styles';
import type { BannerBodyPropsInterface } from './types/banner-body.types';

/**
 * @since 10.0.0
 */

export const BannerBody = forwardRef<HTMLDivElement, BannerBodyPropsInterface>(
  (props, forwardedRef) => {
    const { asChild = false, children, className, css: cssProp, ...rest } = props;

    const styles = css(bannerBodyStyles, cssProp);

    const Component: ElementType = asChild ? Slot : 'div';

    return (
      <Component
        ref={forwardedRef}
        data-c11n-component="Banner.Body"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n-semantic', styles, className)}
        {...rest}
      >
        <BannerIcon />
        <div className="c11n">{children}</div>
      </Component>
    );
  },
);

BannerBody.displayName = 'Banner.Body';
